/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'workorderTransfer': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M748.34 127.982H272.978c-80.101 0-145.035 64.935-145.035 145.035V748.38c0 80.101 64.935 145.035 145.035 145.035H748.34c80.101 0 145.035-64.935 145.035-145.035V273.017c0-80.101-64.934-145.035-145.035-145.035zM578.373 621.505v-101.47c-210.823-35.294-322.51 247.553-322.51 247.553 0-438.25 322.51-411.89 322.51-411.89V253.123l189.175 184.19-189.175 184.191z"/>'
  }
})
